import { resolveAssetUrl } from '../../../../../utils/utils';
import classes from './projectLogo.module.scss';

const ProjectLogo = ({ project }) => {
    return (
        <li className={classes.ProjectLogo}>
            <img
                src={resolveAssetUrl(project.logoSrc)}
                alt=""
                aria-hidden="true"
                className={classes.Image}
            />
        </li>
    );
};

export default ProjectLogo;
